export class LOCIDModel {
  LOCID: string;
  Name: string;
}

export class SelectTDOCIDLOCIDModel {
  TDOCID: string;
  ClientName: string;
  LOCID: number;
  LocationName: string;
}
